import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
	0% { background-position: -500px 0; }
	100% { background-position: 500px 0; }
`;

export const BannerContainer = styled.section`
	background: #000e4b;
	color: #ffffff;
	border-radius: 16px;
	padding: 24px;
	width: 60%; /* Alinhado com o input de pesquisa e outros elementos centralizados da tela */
	margin-top: 24px;
	box-shadow: 0 4px 15px rgba(0, 14, 75, 0.12);
	display: flex;
	flex-direction: column;
	gap: 16px;
	border-left: 4px solid #00d084;

	@media (max-width: 1024px) {
		width: 80%;
	}
	@media (max-width: 768px) {
		width: 100%;
		padding: 16px;
	}
`;

export const BannerHeader = styled.section<{ $isOpenCard: boolean }>`
	background: #000e4b;
	color: #ffffff;
	border-radius: ${({ $isOpenCard }) =>
		$isOpenCard ? "16px 16px 0 0" : "16px"};
	padding: 18px 24px;
	width: 60%;
	margin-top: 24px;
	box-shadow: 0 4px 15px rgba(0, 14, 75, 0.12);
	border-bottom: ${({ $isOpenCard }) =>
		$isOpenCard ? "1px solid rgba(255, 255, 255, 0.15)" : "none"};
	border-left: 4px solid #00d084;

	@media (max-width: 1024px) {
		width: 80%;
	}

	@media (max-width: 768px) {
		width: 100%;
		padding: 16px;
	}
`;

export const BannerBody = styled.section`
	background: #000e4b;
	color: #ffffff;
	border-radius: 0 0 16px 16px;
	padding: 16px 24px 18px;
	width: 60%;
	box-shadow: 0 4px 15px rgba(0, 14, 75, 0.12);
	display: grid;
	grid-template-columns: minmax(0, 3fr) minmax(220px, 1fr);
	gap: 18px;
	border-left: 4px solid #00d084;

	> div:first-child {
		padding-right: 18px;
		border-right: 1px solid rgba(255, 255, 255, 0.12);
	}

	@media (max-width: 1024px) {
		width: 80%;
	}

	@media (max-width: 820px) {
		grid-template-columns: 1fr;

		> div:first-child {
			padding-right: 0;
			border-right: 0;
		}
	}

	@media (max-width: 768px) {
		width: 100%;
		padding: 16px;
	}
`;

export const EmptyStateGrid = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	gap: 20px;

	@media (max-width: 620px) {
		flex-direction: column;
		align-items: flex-start;
	}
`;

export const EmptyLeftColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const EmptyTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const EmptyTitle = styled.h3`
	font-family: "NotoSans-Bold", sans-serif;
	font-size: 20px;
	font-weight: 700;
	margin: 0;
	color: #ffffff;
`;

export const EmptySubtitle = styled.p`
	font-family: "NotoSans-Regular", sans-serif;
	font-size: 12px;
	color: #b8f1e2;
	margin: 0;
`;

export const EmptyRightColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	align-items: flex-end;

	@media (max-width: 620px) {
		width: 100%;
		align-items: flex-start;
	}
`;

export const AIBadge = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;

	> div {
		display: flex;
		align-items: center;
		gap: 10px;
	}
`;

export const AIBadgeButton = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 7px;
	border-radius: 18px;
	background: #27377a;
	color: #00d084;
	padding: 5px 10px;
	font-weight: 800;
	font-size: 10px;
	font-family: "NotoSans-Bold", sans-serif;
	width: fit-content;
`;

export const AIBadgeButtonContainer = styled.button`
	width: 34px;
	height: 34px;
	display: grid;
	place-items: center;
	border: 1px solid rgba(255, 255, 255, 0.7);
	border-radius: 50%;
	padding: 0;
	background: transparent;
	color: #ffffff;
	cursor: pointer;

	&:hover,
	&:focus-visible {
		background: rgba(255, 255, 255, 0.08);
		outline: none;
	}
`;

export const ActiveStateGrid = styled.div`
	display: grid;
	grid-template-columns: 1.6fr 1fr;
	gap: 24px;
	width: 100%;

	@media (max-width: 820px) {
		grid-template-columns: 1fr;
		gap: 20px;
	}
`;

export const LeftColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

export const RightColumn = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 12px;

	> button:last-child {
		width: 100%;
		justify-content: center;
		border-radius: 8px;
	}

	@media (max-width: 820px) {
		align-items: flex-start;
	}
`;

export const PatientHeaderCard = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 14px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.15);
	border-radius: 8px;
	cursor: pointer;
	transition: background-color 0.22s, border-color 0.22s;
	width: 100%;

	&:hover {
		background: rgba(255, 255, 255, 0.08);
		border-color: rgba(255, 255, 255, 0.25);
	}
`;

export const PatientInfoWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const ListAvatar = styled.span<{ $hasPhoto?: boolean }>`
	width: 36px;
	height: 36px;
	border-radius: 50%;
	display: grid;
	place-items: center;
	font-family: "NotoSans-Bold", sans-serif;
	color: #ffffff;
	font-size: 11px;
	font-weight: 800;
	border: 1px solid rgba(255, 255, 255, 0.8);
	background: rgb(0, 14, 75);
	overflow: hidden;
`;

export const ListPhoto = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export const PatientTextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

export const PatientName = styled.span`
	font-family: "NotoSans-Bold", sans-serif;
	font-size: 14px;
	font-weight: 700;
	color: #ffffff;
`;

export const PatientSubtext = styled.span`
	font-family: "NotoSans-Regular", sans-serif;
	font-size: 10px;
	color: #bad2ff;
`;

export const ChevronWrapper = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	color: #ffffff;

	svg {
		width: 14px;
		height: 14px;
	}

	&:focus-visible {
		outline: 2px solid #00d084;
		outline-offset: 4px;
		border-radius: 4px;
	}
`;

export const AnalysisText = styled.p`
	font-family: "NotoSans-Regular", sans-serif;
	font-size: 11px;
	line-height: 1.5;
	color: #ffffff;
	margin: 14px 0 0;

	strong {
		font-family: "NotoSans-Bold", sans-serif;
		color: #00d084;
		margin-right: 4px;
	}
`;

export const HighlightPrefix = styled.strong`
	font-family: "NotoSans-Bold", sans-serif;
	font-weight: 700;
	color: #00d084;
	margin-right: 4px;
`;

export const LeftCTARow = styled.div`
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
	margin-top: 14px;
`;

export const FilledGreenButton = styled.button`
	border-radius: 100px;
	padding: 8px 15px;
	font-size: 11px;
	font-weight: 700;
	font-family: "NotoSans-Bold", sans-serif;
	cursor: pointer;
	border: 0;
	background: #009973;
	color: #ffffff;
	display: flex;
	align-items: center;
	gap: 6px;
	transition: background-color 0.2s ease;

	&:hover {
		background: #00b985;
	}

	&:disabled {
		opacity: 0.65;
		cursor: wait;
	}

	svg {
		width: 12px;
		height: 12px;
	}
`;

export const OutlineDarkButton = styled.button`
	border-radius: 100px;
	padding: 8px 15px;
	font-size: 11px;
	font-weight: 700;
	font-family: "NotoSans-Bold", sans-serif;
	cursor: pointer;
	border: 1px solid rgba(255, 255, 255, 0.2);
	background: rgba(255, 255, 255, 0.05);
	color: #ffffff;
	display: flex;
	align-items: center;
	gap: 6px;
	transition: all 0.2s ease;

	&:hover,
	&:focus-visible {
		background: rgba(255, 255, 255, 0.1);
		outline: none;
	}

	&:disabled {
		opacity: 0.65;
		cursor: wait;
	}
`;

export const MetricsGrid = styled.div`
	display: flex;
	gap: 8px;
	width: 100%;
`;

export const MetricCard = styled.button<{ alert?: boolean }>`
	flex: 1;
	text-align: left;
	cursor: pointer;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid
		${({ alert }) =>
			alert ? "rgba(255, 95, 87, 0.25)" : "rgba(255, 255, 255, 0.15)"};
	border-radius: 10px;
	padding: 12px 11px;
	min-height: 70px;
	display: flex;
	flex-direction: column;
	gap: 4px;
	transition: background-color 0.2s ease, border-color 0.2s ease;

	&:hover,
	&:focus-visible {
		background: rgba(255, 255, 255, 0.1);
		outline: none;
	}
`;

export const MetricLabel = styled.span<{ alert?: boolean }>`
	font-family: "Inter-Bold", sans-serif;
	font-size: 8px;
	font-weight: 700;
	color: ${({ alert }) => (alert ? "#FF5F57" : "#ABADB7")};
	text-transform: uppercase;
	letter-spacing: 0.5px;
`;

export const MetricValue = styled.span<{ alert?: boolean }>`
	font-family: "NotoSans-Bold", sans-serif;
	font-weight: 700;
	display: flex;
	align-items: baseline;
	gap: 5px;
`;

export const MetricNumber = styled.strong<{ alert?: boolean }>`
	font-family: "NotoSans-Bold", sans-serif;
	font-size: 22px;
	line-height: 1;
	color: ${({ alert }) => (alert ? "#FF5F57" : "#FFFFFF")};
`;

export const MetricUnit = styled.span<{ alert?: boolean }>`
	font-family: "NotoSans-Regular", sans-serif;
	font-size: 9px;
	font-weight: 400;
	color: ${({ alert }) => (alert ? "#FF5F57" : "#ABADB7")};
`;

export const AnalysisSkeleton = styled.div`
	width: 100%;
	height: 58px;
	border-radius: 8px;
	margin-top: 14px;
	background: linear-gradient(90deg, #172661 25%, #2c3d7b 50%, #172661 75%);
	background-size: 700px 100%;
	animation: ${shimmer} 1.3s infinite linear;
`;

export const ErrorText = styled.div`
	margin-top: 12px;
	font-family: "NotoSans-Regular", sans-serif;
	font-size: 11px;
	color: #ffffff;

	button {
		border: 0;
		background: transparent;
		color: #2effb2;
		font: inherit;
		font-weight: 700;
		text-decoration: underline;
		cursor: pointer;
		margin-left: 8px;
	}
`;
